<template>
  <v-phone-input
    v-model.lazy="phoneNumber"
     dense filled
    :rules="rules"
    :enableSearchingCountry="false"
    style="display: flex; gap: 20px;"
  >
     <template #selection="{ item }" style="max-width: 181px; border-radius: 6px 6px 0 0;">
      {{item.iso2}}+{{ item.dialCode }}
     </template>
     <template #country-name="{ country }" style="border-radius: 6px 6px 0 0;">
       <strong>+{{ country.dialCode }}</strong>
       {{ country.name }}
     </template>
  </v-phone-input>
</template>

<script>
import { VPhoneInput } from 'v-phone-input'
export default {
  components: {
    VPhoneInput
  },
  props: {
    value: String,
    rules: Array,
    required: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    phoneNumber: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  }
}
</script>

<style lang="scss">
.v-select__selections {
  input {
    display: none !important;
  }
}
.v-phone-input {
  .v-input.v-phone-input__country {
    max-width: 181px !important;
  }
}
</style>
